import { AddInFeatureNotSupportedException } from 'common/exceptions/application/AddInFeatureNotSupportedException';
import { ApiException } from 'common/exceptions/application/ApiException';
import { ApplicationException } from 'common/exceptions/application/ApplicationException';
import { ItemIsNotSavedException } from 'common/exceptions/application/ItemIsNotSavedException';
import { MeetingAlreadySavedException } from 'common/exceptions/application/MeetingAlreadySavedException';
import { Exception } from 'common/exceptions/Exception';
import { AuthException } from 'common/exceptions/http/AuthException';
import AuthInvalidGrantException from 'common/exceptions/http/AuthInvalidGrantException';
import { ConnectionException } from 'common/exceptions/http/ConnectionException';
import { ForbiddenException } from 'common/exceptions/http/ForbiddenException';
import { OutlookApiException } from 'common/exceptions/outlook/OutlookApiException';
import { OutlookException } from 'common/exceptions/outlook/OutlookException';
import { OutlookItemNotSupported } from 'common/exceptions/outlook/OutlookItemNotSupported';
import { OutlookWrongItemSelectedException } from 'common/exceptions/outlook/OutlookWrongItemSelectedException';
import * as Ui from '../utils/uiUtils';

export function errorHandler(error: Exception, friendlyMessage?: string) {
  console.log('Handling error ', friendlyMessage, error);

  friendlyMessage = friendlyMessage || '';
  const errorMessage = error && error.message ? error.message : '';
  const friendlyMessageWithColon = friendlyMessage
    ? friendlyMessage + ': '
    : '';
  const friendlyMessageWithErrorMessage =
    friendlyMessage && errorMessage
      ? friendlyMessageWithColon + errorMessage
      : friendlyMessage + errorMessage;

  // app exceptions that can occur during manual saving
  if (error instanceof ItemIsNotSavedException) {
    Ui.showInfoDialog(
      'Please save this item in Outlook by either selecting File -> Save, or, for meetings, by sending invitations to attendees.' +
        ' If this item is already saved, please try again shortly.'
    );
  } else if (error instanceof MeetingAlreadySavedException) {
    Ui.showInfoDialog(
      'The meeting has already been saved in the selected project.'
    );
  } else if (error instanceof OutlookItemNotSupported) {
    Ui.showInfoDialog('This outlook item is not supported');
  }
  // app exceptions that can occur during manual saving or autosaving
  else if (
    error instanceof AddInFeatureNotSupportedException ||
    error instanceof ApiException ||
    error instanceof ApplicationException
  ) {
    Ui.showErrorInForm(friendlyMessageWithErrorMessage, error);
  }

  // http exceptions
  else if (error instanceof ConnectionException) {
    Ui.showErrorInForm(
      'Internet connection was interrupted. Please try again.',
      error
    );
  } else if (
    error instanceof AuthInvalidGrantException ||
    error instanceof AuthException
  ) {
    Ui.showAuthErrorDialog('Your session has expired please login again.');
    localStorage.clear();
  } else if (error instanceof ForbiddenException) {
    Ui.showErrorInForm(
      friendlyMessageWithColon +
        'You do not have permission to perform this action',
      error
    );
  }

  // unknown Outlook exceptions
  else if (error instanceof OutlookApiException) {
    Ui.showErrorInForm(
      friendlyMessageWithColon +
        'Outlook API error has occurred: ' +
        error.message,
      error
    );
  } else if (error instanceof OutlookException) {
    Ui.showErrorInForm(
      friendlyMessageWithColon + 'Outlook error has occurred: ' + error.message,
      error
    );
  } else if (error instanceof OutlookWrongItemSelectedException) {
    // see JSDoc for this class
    Ui.showErrorInForm(friendlyMessageWithColon + error.message, error);
  }

  // unexpected
  else {
    Ui.showErrorInForm(
      friendlyMessageWithColon +
        'An unexpected error occurred. Please contact support.',
      error
    );
  }
}
